import { UserApiData } from '../../types/user';

interface ConnectionUserData {
	email: string;
	given?: number;
	id: string;
	imageUrl: string;
	name: string;
	received?: number;
	username: string;
}

export class ConnectionUser {
	email: string;
	given?: number;
	id: string;
	imageUrl: string;
	name: string;
	received?: number;
	username: string;

	constructor(data: ConnectionUserData) {
		this.email = data.email;
		this.given = data.given;
		this.id = data.id;
		this.imageUrl = data.imageUrl;
		this.name = data.name;
		this.received = data.received;
		this.username = data.username;
	}

	public static fromApiData(data: UserApiData) {
		return new ConnectionUser({
			email: data.email,
			given: data.given,
			id: data.id,
			imageUrl: data.profile_pic_url,
			name: data.display_name,
			received: data.received,
			username: data.username,
		});
	}
}
